<template>
  <el-card v-loading="isLoading" shadow="always">
    <template #header>
      <el-row type="flex" justify="space-between" align="center">
        <h4>{{ PageTitle }}</h4>
        <el-col :md="15">
          <el-row type="flex" justify="end">
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="medium"
              @click="openLabelModal(null)"
            >
              Cadastrar nova etiqueta
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </template>

    <section
      v-for="group in GroupedLabels"
      :key="group.name"
      class="label-group"
    >
      <div class="label-group__header">
        <strong>{{ group.name }}</strong>
        <span>{{ group.labels.length }} etiqueta(s)</span>
      </div>

      <el-table
        stripe
        :cell-style="() => 'text-align:center;'"
        :data="group.labels"
        style="width: 100%; z-index: 0"
      >
        <el-table-column prop="name" label="nome"></el-table-column>
        <el-table-column prop="description" label="descrição"></el-table-column>
        <el-table-column label="criado em">
          <template #default="scope">
            {{ dateFormatter.format(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="atualizado em">
          <template #default="scope">
            {{ dateFormatter.format(scope.row.updated_at) }}
          </template>
        </el-table-column>
        <el-table-column label="ações" :width="150" fixed="right">
          <template #default="scope">
            <el-row type="flex" justify="end">
              <el-button-group>
                <el-button
                  onlyIcon
                  title="Editar etiqueta"
                  type="primary"
                  circle
                  @click="openLabelModal(scope.row)"
                >
                  <i class="el-icon-edit"></i>
                </el-button>
                <el-button
                  onlyIcon
                  title="Imprimir etiqueta"
                  type="primary"
                  circle
                  @click="openPrintModal(scope.row)"
                >
                  <i class="el-icon-printer"></i>
                </el-button>
                <el-popconfirm
                  @confirm="deleteLabel(scope.row)"
                  title="Remover etiqueta?"
                >
                  <template #reference>
                    <el-button
                      onlyIcon
                      title="Remover etiqueta"
                      type="danger"
                      circle
                    >
                      <i class="el-icon-delete"></i>
                    </el-button>
                  </template>
                </el-popconfirm>
              </el-button-group>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </section>

    <label-modal
      :showModal="showLabelModal"
      :label="label"
      @close-modal="showLabelModal = false"
      @should-update="fetchLabels"
    ></label-modal>

    <label-print-modal
      :showModal="showPrintModal"
      :label="label"
      default-print-context="product"
      @close-modal="showPrintModal = false"
    ></label-print-modal>
  </el-card>
</template>

<script>
import LabelModal from "./modals/LabelModal.vue";
import LabelPrintModal from "./modals/LabelPrintModal.vue";
import LabelService from "../services/labels.js";
import { dateFormatter } from "../utils/formatters.js";

export default {
  name: "Labels",
  components: { LabelModal, LabelPrintModal },
  data: () => ({
    isLoading: true,
    labels: [],
    label: null,
    dateFormatter,
    showLabelModal: false,
    showPrintModal: false,
  }),
  computed: {
    PageTitle() {
      return this.$route.path.includes("impressao")
        ? "Impressão de Etiquetas"
        : "Etiquetas Cadastradas";
    },
    GroupedLabels() {
      const groups = this.labels.reduce((total, label) => {
        const group = this.normalizeGroup(label.group) || "SEM GRUPO";

        if (!total[group]) total[group] = [];
        total[group].push(label);

        return total;
      }, {});

      return Object.keys(groups)
        .sort((a, b) => {
          if (a === "SEM GRUPO") return 1;
          if (b === "SEM GRUPO") return -1;
          return a.localeCompare(b);
        })
        .map((name) => ({ name, labels: groups[name] }));
    },
  },
  mounted() {
    this.fetchLabels();
  },
  methods: {
    normalizeGroup(group) {
      const normalizedGroup = String(group || "").trim().toUpperCase();

      return normalizedGroup || null;
    },
    openLabelModal(label) {
      this.label = label;
      this.showLabelModal = true;
    },
    openPrintModal(label) {
      this.label = label;
      this.showPrintModal = true;
    },
    async fetchLabels() {
      this.isLoading = true;
      const { labels, error } = await LabelService().index();

      if (labels) this.labels = labels;
      else
        this.$notify({
          title: "Não foi possível carregar as etiquetas",
          message: error?.message,
          type: "error",
          position: "bottom-right",
        });

      this.isLoading = false;
    },
    async deleteLabel(label) {
      const { label: result, error } = await LabelService(label.uid).delete();

      if (result) {
        this.fetchLabels();
        this.$notify({
          title: "Etiqueta removida com sucesso",
          type: "success",
          position: "bottom-right",
        });
      } else
        this.$notify({
          title: "Não foi possível remover a etiqueta",
          message: error?.message,
          type: "error",
          position: "bottom-right",
        });
    },
  },
};
</script>

<style scoped>
.el-card {
  width: 100%;
}

.label-group + .label-group {
  margin-top: 22px;
}

.label-group__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid #ebeef5;
  border-bottom: 0;
  border-radius: 4px 4px 0 0;
  background: #f5f7fa;
  color: #303133;
}

.label-group__header span {
  color: #606266;
  font-size: 12px;
}
</style>
